export default "__VITE_ASSET__1fb64d4e__"